import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { blogApi } from '../../services/api';
import logger from '../../utils/logger';
// Image from public folder
const LUMO = "/assets/images/LUMO-Icon-Primary-Padded.png";

const BLOGS_PER_PAGE = 3;

function Articals() {
    const [blogData, setBlogData] = useState([]);
    const [categories, setCategories] = useState([]);
    const [filteredBlogs, setFilteredBlogs] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function loadData() {
            try {
                // Fetch public blog posts and categories
                const [posts, cats] = await Promise.all([
                    blogApi.fetchPublicBlogPosts(),
                    blogApi.fetchAllBlogCategories(),
                ]);

                // For each blog post, fetch its category if available
                const postsWithCategories = await Promise.all(
                    posts.map(async (post) => {
                        if (post.category) {
                            try {
                                const category = await blogApi.fetchBlogCategoryById(post.category);
                                return { ...post, category };
                            } catch (err) {
                                logger.warn('Failed to fetch category for blog post', err, { postId: post.id });
                                return post;
                            }
                        }
                        return post;
                    })
                );

                // Fetch comments count for each post
                const postsWithComments = await Promise.all(
                    postsWithCategories.map(async (post) => {
                        try {
                            const comments = await blogApi.fetchBlogPostComments(post.id);
                            return { ...post, commentsCount: comments.length };
                        } catch (err) {
                            logger.warn('Failed to fetch comments for blog post', err, { postId: post.id });
                            return { ...post, commentsCount: 0 };
                        }
                    })
                );

                setBlogData(postsWithComments);
                setCategories(cats || []);
                setFilteredBlogs(postsWithComments);
            } catch (error) {
                logger.error('Failed to load blog data', error);
            } finally {
                setLoading(false);
            }
        }

        loadData();
    }, []);

    const formatDate = (isoDate) => {
        if (!isoDate) return 'Unknown date';
        const date = new Date(isoDate);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
        });
    };

    const capitalizeWord = (word) => {
        return String(word).charAt(0).toUpperCase() + String(word).slice(1);
    }

    const isNew = (isoDate) => {
        if (!isoDate) return false;
        const date = new Date(isoDate);
        const today = new Date();
        const diffTime = today - date;
        const diffDays = diffTime / (1000 * 60 * 60 * 24);
        return diffDays <= 7;
    };

    const handleCategoryClick = (categoryName) => {
        setSelectedCategory(categoryName);
        setCurrentPage(1);

        if (categoryName === 'All') {
            setFilteredBlogs(blogData);
        } else {
            setFilteredBlogs(blogData.filter((blog) =>
                blog.category &&
                `${blog.category.domain} - ${blog.category.name}` === categoryName
            ));
        }
    };

    const totalPages = Math.ceil(filteredBlogs.length / BLOGS_PER_PAGE);
    const currentBlogs = filteredBlogs.slice(
        (currentPage - 1) * BLOGS_PER_PAGE,
        currentPage * BLOGS_PER_PAGE
    );

    const handlePrev = () => {
        if (currentPage > 1) setCurrentPage((prev) => prev - 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
    };

    const handlePageClick = (page) => {
        setCurrentPage(page);
    };

    if (loading) {
        return <div className="container">Se încarcă postările...</div>;
    }

    return (
        <>
            <section className="articles_section row_am">
                <div className="container">
                    <div className="section_title" data-aos="fade-up" data-aos-duration={1500}>
                        <h2>Articole <span>recente</span></h2>
                    </div>

                    {/* Filter tags with your classes */}
                    <ul className="filter_tags" data-aos="fade-up" data-aos-duration={1500}>
                        <li>
                            <Link to="#" className={selectedCategory === 'All' ? 'active' : ''} onClick={() => handleCategoryClick('All')}>
                                Toate
                            </Link>
                        </li>
                        {categories.map((cat) => (
                            <li key={cat.id}>
                                <Link to="#"
                                    className={selectedCategory === `${cat.domain} - ${cat.name}` ? 'active' : ''}
                                    onClick={() => handleCategoryClick(`${cat.domain} - ${cat.name}`)}
                                >
                                    {cat.domain} - {cat.name}
                                </Link>
                            </li>
                        ))}
                    </ul>

                    {/* Blog listings */}
                    <div className="blog_listings">
                        {currentBlogs.length === 0 ? (
                            <p>Nu am găsit nicio postare...</p>
                        ) : (
                            currentBlogs.map((blog) => {
                                const formattedDate = formatDate(blog.created_at);
                                const formattedCategory = blog.category
                                    ? `${blog.category.domain} - ${blog.category.name}`
                                    : 'Uncategorized';

                                return (
                                    <div key={blog.id} className="listing_block" data-aos="fade-up" data-aos-duration={1500}>
                                        <Link to={`/blog/${blog.id}`} className="img">
                                            <img src={blog.thumbnail} alt="blog" />
                                            {isNew(blog.created_at) && <span className="new_badge">NOU!</span>}
                                        </Link>
                                        <div className="blog_text">
                                            <span className="tag">{formattedCategory}</span>
                                            <h2>
                                                <Link to={`/blog/${blog.id}`}>{blog.title}</Link>
                                            </h2>
                                            <Link to={`/blog/${blog.id}`}>
                                                Citește mai mult <i className="icofont-arrow-right" />
                                            </Link>
                                        </div>
                                        <div className="authore_info d-flex flex-column align-items-start">
                                            <div className='blog_info d-flex flex-column align-items-center'>
                                                <span className='blog_date'>{formattedDate}</span>
                                                <div className='blog_stats d-flex flex-ror'>
                                                    <span>❤️ {blog.likes}</span>    
                                                    <span>💬 {blog.commentsCount}</span>
                                                </div>
                                            </div>
                                            <div className="avtar d-flex flex-row ">
                                                <img src={blog.authorImage ? LUMO : blog.authorImage} alt="author" className="avatar-img" />
                                                <div className="text d-flex flex-column gap-0">
                                                    <h3>{ blog.authorName === ("Undefined" || "undefined" || "") ? "LUMO Digital" : capitalizeWord(blog.authorName) }</h3>
                                                    <span>Autor postare</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>

                    {/* Pagination with your original structure */}
                    {totalPages > 1 && (
                        <div className="pagination_block" data-aos="fade-in" data-aos-duration={1500}>
                            <ul>
                                <li>
                                    <Link to="#" className="prev" onClick={handlePrev}>
                                        <i className="icofont-arrow-left" /> Precedent
                                    </Link>
                                </li>
                                {Array.from({ length: totalPages }, (_, index) => (
                                    <li key={index}>
                                        <Link
                                            to="#"
                                            className={currentPage === index + 1 ? 'active' : ''}
                                            onClick={() => handlePageClick(index + 1)}
                                        >
                                            {index + 1}
                                        </Link>
                                    </li>
                                ))}
                                <li>
                                    <Link to="#" className="next" onClick={handleNext}>
                                        Următor <i className="icofont-arrow-right" />
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    )}
                </div>
            </section>
        </>
    );
}

export default Articals;
